import React from "react";
import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import ProductTour from "../../components/v2/product/product-tour";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import AgentIntegration from "../../components/v2/agent-integration";
import {Docker, K8s, Linux, Windows} from "../../components/v2/icons";
import "../../styles/scss/_faq-section.module.scss";

export default function AiSearch() {
    const { t } = useTranslation("common");
    const featuresData = t('product.ai-search.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.ai-search.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.ai-search.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const cardWithIconData = t('product.ai-search.cardWithIcon', { returnObjects: true }) as any[]

    const productTourData = t('product.ai-search.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.ai-search.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.agentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={<h1>{t('product.ai-search.hero.title')} </h1>}
                                description={t('product.ai-search.hero.description')}
                                img={"/images/product/ai-search.png"} imgMobile={"/images/product/ai-search-mobile.webp"} imgAlt={t('product.ai-search.hero.imageAlt')} preloadImg hasActions={true} className={"llm-page"} tips={t('product.hero.tips')}/>


            <FeaturesMonitoring productFeatures={features} title={<h2>{t('product.ai-search.section.title')}</h2>} tourId={"ai-search-tour"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/cm38gvpsk0ssd8hsp7tyiqqoy?embed_v=2"} title={productTourData.title} tourId={"ai-search-tour"} description={productTourData.description} titleChanged={<h2><Trans i18nKey="product.ai-search.productTour.titleChanged" components={{ highlight: <span /> }} /></h2>}/>

            <AgentIntegration
                agentDeploy={agentDeploy}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.ai-search.agentIntegration.title"
                            components={{ highlight: <span className="text-gradient" /> }}
                        />
                    </h2>
                }
                description={agentIntegrationData.description}
            />

            <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.ai-search.faq.title')}</h2>
                    <p>{t('product.ai-search.section.description')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>
        </>
    )
}